import { get } from 'lodash';

export const getFormFactor = wixCodeApi => get(wixCodeApi, ['window', 'formFactor']);

export const getIsNotEditor = wixCodeApi => get(wixCodeApi, ['window', 'viewMode']) !== 'Editor';
